export const environment = {
  production: true,
  API_BASE_URL: '/api',
  BASE_URL: '',
  COUNTRY_SEARCH_RESTRICTION: 'AU',
  // API_BASE_URL: 'http://localhost:3000/api',
  // BASE_URL: 'http://localhost:3000'
};
